

















import Vue from 'vue'
import DocumentationsFormTitle from '@/UI/Auction/Documentations/DocumentationsFormTitle.vue'
import DocumentationTableHeader from '@/UI/UserProcedures/BidProcedures/Review/DocumentationTableHeader.vue'
import DocumentationTableRow from '@/UI/UserProcedures/BidProcedures/Review/DocumentationTableRow.vue'
import { ReviewedDocumentationDTO } from '@/Application/ReviewedDocumentation/ReviewedDocumentationDTO'

export default Vue.extend({
  name: 'ReviewForm',
  components: {
    DocumentationsFormTitle,
    DocumentationTableHeader,
    DocumentationTableRow
  },
  props: {
    reviewDoc: {
      type: ReviewedDocumentationDTO,
      required: true
    }
  }
})
